/**
 * Inspired by https://embed.plnkr.co/plunk/9XMUVr
 */

import type {IRootScopeService} from 'angular';
import {isPromise} from 'shared/utils/custom-utils';

/**
 * @ngdoc filter
 * @name async
 * @module portaro.filters
 */
/*@ngInject*/
export default function asyncFilter($rootScope: IRootScopeService) {
    const hash: WeakMap<any, { result: any }> = new WeakMap();

    function asyncMe(value) {
        if (hash.get(value)) {
            return hash.get(value).result;
        }

        if (isPromise(value)) {
            hash.set(value, {result: null});

            value.then((result) => {
                hash.set(value, {result});
            });

            return null;
        }

        if (value.subscribe && typeof value.subscribe === 'function') {
            hash.set(value, {result: null});

            value.subscribe((result) => {
                $rootScope.$apply();
                hash.set(value, {result});
            });

            return null;
        }

        return value;
    }

    asyncMe.$stateful = true;

    return asyncMe;
}

asyncFilter.filterName = 'async';
